import React from 'react';
import { Typography } from 'views/components/atoms/Typography';
import { Color, FontSize } from 'views/constants';
import styled from '@emotion/styled';

interface WrapperProps {
  maxWidth?: string;
}

const Wrapper = styled.div<WrapperProps>`
  max-width: ${({ maxWidth }): string => (maxWidth ? maxWidth : 'initial')};
  text-align: center;
`;

interface ErrorMessagesProps {
  message: string;
  maxWidth?: string;
}

export const ErrorMessage: React.FC<ErrorMessagesProps> = ({
  message,
  maxWidth,
}) => (
  <Wrapper maxWidth={maxWidth}>
    <Typography el="p" color={Color.C11} size={FontSize.XS} block>
      {message}
    </Typography>
  </Wrapper>
);
